import { GameProject } from '../types';

export const gameProjects: GameProject[] = [
  {
    id: 'atom3d-engine',
    title: 'Atom3D Engine & Toolset',
    category: 'Game Engine',
    description: 'High-performance modular 3D game engine featuring modern physically based rendering (PBR), GPU particle systems, dynamic scene graph orchestration, and spatial audio.',
    techStack: ['C++', 'Vulkan / OpenGL', 'GLSL', 'ECS'],
    githubUrl: 'https://github.com/atomixgame',
    image: '/images/brand/game-atom3d.jpg',
    featured: true,
    status: 'Open Source'
  },
  {
    id: 'atomgdx-framework',
    title: 'AtomGdx Game Framework',
    category: 'Game Engine',
    description: 'Cross-platform lightweight 2D/3D framework built for ultra-fast prototyping, seamless multi-platform deployment (Desktop, Android, WebGL), and zero-friction indie pipelines.',
    techStack: ['Java / Kotlin', 'LibGDX Core', 'Shaders', 'Physics2D'],
    githubUrl: 'https://github.com/atomixgame',
    image: '/images/brand/game-atomgdx.jpg',
    featured: true,
    status: 'Open Source'
  },
  {
    id: 'atomix-game-engine',
    title: 'Atomix Game Engine Architecture',
    category: 'Open Source Tool',
    description: 'Data-driven Entity Component System (ECS) with hot-reloading shaders, multi-threaded asset streaming, and deterministic math libraries for open-source developers.',
    techStack: ['Rust / C++', 'Vulkan', 'WebAssembly', 'OpenXR'],
    githubUrl: 'https://github.com/atomixgame',
    image: '/images/brand/game-atom3d.jpg',
    featured: false,
    status: 'Open Source'
  },
  {
    id: 'cyberwave-neon-horizon',
    title: 'CyberWave: Neon Horizon',
    category: 'Steam Game',
    description: 'Adrenaline-fueled cyberpunk action runner and tactical stealth adventure powered by AtomixGame engines, featuring procedural synthwave levels and generative boss AI.',
    techStack: ['Atom3D Engine', 'Procedural Audio', 'Steamworks API'],
    steamUrl: 'https://store.steampowered.com/',
    githubUrl: 'https://github.com/atomixgame',
    image: '/images/brand/game-cyberwave.jpg',
    featured: true,
    status: 'In Development'
  },
  {
    id: 'orbit-shift-mobile',
    title: 'Orbit Shift: Quantum Odyssey',
    category: 'Mobile Game',
    description: 'Mind-bending gravity puzzle arcade game designed with tactile haptics, generative fractal backgrounds, and responsive mobile-first physics simulations.',
    techStack: ['AtomGdx', 'OpenGL ES 3.0', 'App Store / iOS', 'Google Play'],
    appStoreUrl: 'https://apps.apple.com/',
    image: '/images/brand/game-orbit-shift.jpg',
    featured: false,
    status: 'Live'
  }
];
